export const BRAND = "THE TRIP WORLD";
export const TAGLINE = "YOUR JOURNEY STARTS HERE";
export const PHONE = "+91 99888 50202";
export const PHONE_LINK = "tel:+919988850202";
export const WHATSAPP_LINK =
  "https://wa.me/919988850202?text=Hello%20THE%20TRIP%20WORLD%20team%2C%20I%20want%20to%20enquire%20about%20visa%20services.";
export const EMAIL = "customercare@thetrip.world";
export const ADDRESS = "Ahmadgarh, Near Bus Stand, Punjab, India";
export const MAP_EMBED =
  "https://www.google.com/maps?q=Ahmadgarh,+Punjab,+India&output=embed";

export const NAV_LINKS = [
  { key: "home", label: "Home", to: "/" },
  { key: "about", label: "About Us", to: "/about" },
  { key: "services", label: "Services", to: "/services" },
  { key: "countries", label: "Countries", to: "/countries" },
  { key: "why", label: "Why Choose Us", to: "/#why-choose" },
  { key: "stories", label: "Success Stories", to: "/#success-stories" },
  { key: "faq", label: "FAQ", to: "/#faq" },
  { key: "blog", label: "Blog", to: "/blog" },
  { key: "contact", label: "Contact", to: "/contact" },
];

export const VISA_TYPES = [
  "Work Permit Visa",
  "Visitor Visa",
  "Student Visa",
  "Family / Spouse Visa",
  "Business Visa",
  "Immigration Consultation",
  "Documentation Assistance",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=2000&q=80",
  aboutMain: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1000&q=80",
  aboutSecondary: "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?auto=format&fit=crop&w=800&q=80",
  eligibility: "https://images.unsplash.com/photo-1500835556837-99ac94a94552?auto=format&fit=crop&w=1000&q=80",
  documents: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80",
  cta: "https://images.unsplash.com/photo-1520437358207-323b43b50729?auto=format&fit=crop&w=1600&q=80",
};

export const SERVICES = [
  {
    slug: "work-permit-visa",
    icon: "Briefcase",
    title: "Work Permit Visa",
    short: "Guidance for applicants exploring overseas employment and work permit pathways.",
    description:
      "Planning to work abroad? The Trip World provides structured consultation for work permit applications — from understanding employer and job-offer documentation requirements to organising your application file.",
    points: [
      "Profile and occupation review",
      "Employer and offer documentation guidance",
      "Application file preparation",
      "Guidance through applicable process stages",
    ],
  },
  {
    slug: "visitor-visa",
    icon: "Plane",
    title: "Visitor Visa",
    short: "Assistance for tourism, family visits and short-stay travel visa applications.",
    description:
      "Whether you are travelling for tourism, meeting family, or attending an event, we help you understand visitor visa requirements and prepare a well-organised application.",
    points: [
      "Travel purpose and itinerary guidance",
      "Financial documentation support",
      "Invitation and sponsorship document review",
      "Application preparation assistance",
    ],
  },
  {
    slug: "student-visa",
    icon: "GraduationCap",
    title: "Student Visa",
    short: "Support for students planning international education and study permits.",
    description:
      "From choosing a destination to preparing your study permit file, we assist students with consultation, documentation and application preparation for international education.",
    points: [
      "Course and destination consultation",
      "Admission and enrolment document guidance",
      "Financial proof organisation",
      "Study permit application assistance",
    ],
  },
  {
    slug: "family-spouse-visa",
    icon: "HeartHandshake",
    title: "Family / Spouse Visa",
    short: "Guidance for family reunification and spouse visa application processes.",
    description:
      "Reuniting with family abroad requires careful documentation. We assist with relationship evidence organisation, sponsorship documentation and application preparation.",
    points: [
      "Relationship documentation guidance",
      "Sponsorship requirement review",
      "Application file organisation",
      "Process-stage support",
    ],
  },
  {
    slug: "business-visa",
    icon: "Building2",
    title: "Business Visa",
    short: "Assistance for business travel, meetings and short commercial visits abroad.",
    description:
      "For entrepreneurs and professionals travelling for meetings, conferences or commercial exploration, we help prepare business visa documentation and applications.",
    points: [
      "Business travel purpose documentation",
      "Invitation letter guidance",
      "Financial and company document organisation",
      "Application preparation support",
    ],
  },
  {
    slug: "documentation-assistance",
    icon: "FileCheck",
    title: "Documentation & Application Assistance",
    short: "Professional support in organising and preparing your complete application file.",
    description:
      "A strong application starts with organised documentation. We review, structure and prepare your documents so your application file is clear, complete and professionally presented.",
    points: [
      "Document checklist preparation",
      "File review and organisation",
      "Form-filling guidance",
      "Application readiness review",
    ],
  },
];

export const SERVICE_ALIASES = SERVICES.map((s) => s.slug);

export const COUNTRIES = [
  {
    slug: "canada",
    name: "Canada",
    code: "ca",
    image: "https://images.unsplash.com/photo-1517935706615-2717063c2225?auto=format&fit=crop&w=1200&q=80",
    blurb: "A leading destination for skilled workers, students and families.",
    overview:
      "Canada remains one of the most sought-after destinations for work, study and immigration. The Trip World assists applicants with consultation and documentation for Canadian work permits, study permits and visitor visas.",
    pathways: ["Work Permits", "Study Permits", "Visitor Visas", "Family Sponsorship"],
  },
  {
    slug: "united-kingdom",
    name: "United Kingdom",
    code: "gb",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1200&q=80",
    blurb: "World-class universities and global career opportunities.",
    overview:
      "The United Kingdom attracts students, professionals and visitors from across the world. We provide guidance on UK visa categories, documentation requirements and application preparation.",
    pathways: ["Student Visas", "Work Visas", "Visitor Visas", "Family Visas"],
  },
  {
    slug: "australia",
    name: "Australia",
    code: "au",
    image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=1200&q=80",
    blurb: "A vibrant destination for education, work and travel.",
    overview:
      "Australia offers strong opportunities for international students and skilled workers. Our team assists with consultation and document preparation for Australian visa applications.",
    pathways: ["Student Visas", "Work Visas", "Visitor Visas"],
  },
  {
    slug: "usa",
    name: "USA",
    code: "us",
    image: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?auto=format&fit=crop&w=1200&q=80",
    blurb: "Business, tourism and study in the United States.",
    overview:
      "From business travel to tourism and education, the United States offers diverse visa categories. We help applicants understand requirements and prepare organised application files.",
    pathways: ["Visitor Visas (B1/B2)", "Student Visas", "Business Travel"],
  },
  {
    slug: "new-zealand",
    name: "New Zealand",
    code: "nz",
    image: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?auto=format&fit=crop&w=1200&q=80",
    blurb: "Stunning landscapes with quality education and work options.",
    overview:
      "New Zealand is known for its quality of life, education and natural beauty. The Trip World assists with consultation and documentation for New Zealand visa applications.",
    pathways: ["Student Visas", "Work Visas", "Visitor Visas"],
  },
  {
    slug: "europe",
    name: "Europe (Schengen)",
    code: "eu",
    image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=1200&q=80",
    blurb: "Travel across multiple European countries on a Schengen visa.",
    overview:
      "A Schengen visa opens the door to travel across much of Europe. We assist with documentation, itinerary planning and application preparation for Schengen visitor visas.",
    pathways: ["Schengen Visitor Visas", "Business Travel", "Family Visits"],
  },
  {
    slug: "germany",
    name: "Germany",
    code: "de",
    image: "https://images.unsplash.com/photo-1560969184-10fe8719e047?auto=format&fit=crop&w=1200&q=80",
    blurb: "Europe's economic powerhouse for work and study.",
    overview:
      "Germany offers excellent opportunities for students and skilled professionals. We provide consultation and documentation assistance for German visa applications.",
    pathways: ["Student Visas", "Work Visas", "Job Seeker Pathways"],
  },
  {
    slug: "france",
    name: "France",
    code: "fr",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1200&q=80",
    blurb: "Culture, education and business in the heart of Europe.",
    overview:
      "France welcomes students, tourists and business travellers alike. Our team assists with consultation and document organisation for French visa applications.",
    pathways: ["Visitor Visas", "Student Visas", "Business Visas"],
  },
  {
    slug: "uae",
    name: "UAE",
    code: "ae",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80",
    blurb: "A global hub for careers, business and tourism.",
    overview:
      "The UAE is a leading destination for employment, business and leisure travel. We assist with guidance and documentation for UAE visa applications.",
    pathways: ["Employment Visas", "Visit Visas", "Business Travel"],
  },
];

export const WHY_CHOOSE = [
  {
    icon: "UserCheck",
    title: "Personalized Guidance",
    text: "Guidance based on each applicant's circumstances, goals and travel history.",
  },
  {
    icon: "FolderCheck",
    title: "Documentation Support",
    text: "Professional assistance with organising application documents.",
  },
  {
    icon: "MessagesSquare",
    title: "Transparent Communication",
    text: "Clear information about requirements and application steps.",
  },
  {
    icon: "BadgeCheck",
    title: "Professional Approach",
    text: "A structured and organised consultation process from start to finish.",
  },
  {
    icon: "Route",
    title: "End-to-End Assistance",
    text: "Support throughout the relevant stages of the application.",
  },
  {
    icon: "HeartHandshake",
    title: "Client Focused",
    text: "A consultation experience designed around each applicant's goals.",
  },
];

export const STEPS = [
  { num: "01", title: "Consultation", text: "Discuss your travel or immigration goals with our team." },
  { num: "02", title: "Profile & Document Review", text: "Review basic information and documentation requirements." },
  { num: "03", title: "Application Preparation", text: "Prepare and organise the required documents." },
  { num: "04", title: "Application Support", text: "Guidance through the applicable application process." },
];

export const DOC_CHECKLIST = [
  { icon: "BookUser", title: "Passport", text: "Valid passport with sufficient validity and blank pages." },
  { icon: "Camera", title: "Photographs", text: "Recent photographs meeting the destination's specifications." },
  { icon: "Landmark", title: "Financial Documents", text: "Bank statements and proof of funds as applicable." },
  { icon: "GraduationCap", title: "Educational Documents", text: "Degrees, diplomas and academic transcripts." },
  { icon: "Briefcase", title: "Employment Documents", text: "Experience letters, offers and employer records." },
  { icon: "Plane", title: "Travel History", text: "Previous visas and international travel records." },
  { icon: "MailOpen", title: "Invitation / Supporting Documents", text: "Invitations, sponsorship or enrolment letters." },
  { icon: "Files", title: "Other Supporting Documents", text: "Category-specific documents as required." },
];

export const FAQS = [
  {
    q: "What visa services does The Trip World provide?",
    a: "We provide consultation and application assistance for work permit visas, visitor visas, student visas, family/spouse visas, business visas, and complete documentation support for international travel and immigration.",
  },
  {
    q: "How do I start my visa application?",
    a: "Start with a free consultation. Share your travel or immigration goal, and our team will review your profile, explain the general requirements, and outline the steps and documents relevant to your situation.",
  },
  {
    q: "What documents are generally required?",
    a: "Common documents include a valid passport, photographs, financial records, educational and employment documents, and travel history. Exact requirements vary by country, visa category and individual circumstances.",
  },
  {
    q: "How long does visa processing take?",
    a: "Processing times are decided by the relevant immigration authority and vary by country, visa category and application volume. We share current indicative timelines during your consultation.",
  },
  {
    q: "Can you help me prepare my documents?",
    a: "Yes. Documentation and application assistance is one of our core services. We help you organise, review and prepare a clear, complete application file.",
  },
  {
    q: "Can you check my eligibility?",
    a: "Yes. Use our online eligibility checker or book a consultation. Please note this is a preliminary assessment only — final eligibility and visa decisions are made by the relevant immigration authority.",
  },
  {
    q: "Which countries do you assist with?",
    a: "We assist with applications for Canada, the United Kingdom, Australia, the USA, New Zealand, Europe (Schengen), Germany, France and the UAE, with support for additional destinations on request.",
  },
  {
    q: "Does The Trip World guarantee visa approval?",
    a: "No. Visa decisions are made solely by the relevant immigration authority, and no consultancy can guarantee approval. We provide honest guidance and professional application assistance to present your case clearly.",
  },
];

export const BLOG_CATEGORIES = [
  "Visa Updates",
  "Immigration News",
  "Travel Tips",
  "Documentation",
  "Country Guides",
  "Visa FAQs",
];

export const EDUCATION_LEVELS = [
  "High School",
  "Diploma",
  "Bachelor's Degree",
  "Master's Degree",
  "Doctorate / PhD",
  "Other",
];

export const EXPERIENCE_LEVELS = [
  "No experience",
  "Less than 1 year",
  "1–3 years",
  "3–5 years",
  "5–10 years",
  "10+ years",
];

export const ENGLISH_STATUS = [
  "Not taken yet",
  "IELTS — taken",
  "PTE — taken",
  "Planning to take",
  "Not applicable",
];

export const ELIGIBILITY_DISCLAIMER =
  "This is a preliminary assessment only. Final visa decisions are made by the relevant immigration authority and eligibility does not guarantee visa approval.";

export const SITE_DISCLAIMER =
  "THE TRIP WORLD is an immigration and visa consultancy. Visa applications are subject to the requirements and decisions of the relevant immigration authorities. Application assistance does not guarantee visa approval.";
